<template>
  <div id="forgot-password">
    <div
      id="reset-password-successful"
      class="reset-password-area"
      v-if="reset_password_success"
    >
      <h1 class="reset-password-title">
        {{ $t(`message.mailSent`) }}
      </h1>
      <p>{{ $t(`message.resetPasswordRequested`) }}</p>
    </div>
    <div
      id="reset-password-successful"
      class="reset-password-area"
      v-else-if="resent_mail_validation"
    >
      <h1 class="reset-password-title">
        {{ $t(`message.account.yourAccountNotActive`) }}
      </h1>
      <p>{{ $t(`message.validationEmailSended`) }}</p>
      <p>
        {{ $t(`message.checkSpam`) }}
      </p>
    </div>
    <div
      id="reset-password-successful"
      class="reset-password-area"
      v-else-if="resent_set_password"
    >
      <h1 class="reset-password-title">
        {{ $t(`message.account.yourAccountNotActive`) }}
      </h1>
      <p>{{ $t(`message.invitationNotAccepted`) }}</p>
      <p class="mail-resent-text-area">
        {{ $t(`message.setPasswordMailResent`) }}
      </p>
    </div>
    <div class="reset-password-area" v-else>
      <h1 class="reset-password-title">
        {{ $t(`message.restPasswordTitle`) }}
      </h1>
      <div class="form">
        <div class="input-group form-row">
          <input
            type="email"
            class="form-control"
            :class="{
              'is-valid': v$.form.email.$dirty && !v$.form.email.$error,
              'is-invalid': v$.form.email.$dirty && v$.form.email.$error,
            }"
            :placeholder="$t(`message.email`)"
            v-model="form.email"
          />
          <div class="invalid-feedback" v-if="v$.form.email.$error">
            {{ $t(`message.mandatoryFieldWithFormat`) }}
          </div>
        </div>
        <div
          class="spinner-border"
          role="status"
          v-if="$store.getters['loadings/isLoading']"
        >
          <span class="visually-hidden">{{ $t(`message.loading`) }}...</span>
        </div>
        <div class="validation_area" v-else>
          <button @click="resetPassword" class="pill">
            {{ $t(`message.submit`) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "ForgotPassword",
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      reset_password_success: false,
      resent_mail_validation: false,
      resent_set_password: false,
      form: {
        email: "",
      },
    };
  },
  validations() {
    return {
      form: {
        email: {
          required,
          email,
        },
      },
    };
  },
  methods: {
    resetPassword() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        // No error, Reset password
        this.$store
          .dispatch("users/resetPassword", { email: this.form.email })
          .then((response) => {
            if (response.status == 200) {
              if (response.data.code === "reset_password") {
                this.reset_password_success = true;
              } else if (response.data.code === "mail_validation") {
                this.resent_mail_validation = true;
              } else if (response.data.code === "set_password") {
                this.resent_set_password = true;
              }
            }
          })
          .catch((error) => {
            // TODO ici
            if (error.response.status == 409) {
              // Account with this email does not exist
              this.$store.dispatch(
                "notifications/addError",
                {
                  message: this.$t(
                    `message.notifications.account.accountDoesNotExists`,
                  ),
                },
                { root: true },
              );
            } else {
              this.$store.dispatch(
                "notifications/addError",
                {
                  message: this.$t(`message.notifications.forgotPasswordError`),
                },
                { root: true },
              );
            }
          })
          .finally(() => {
            this.$store.dispatch(
              "loadings/disableLoadings",
              {},
              { root: true },
            );
          });
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
#forgot-password {
  position: relative;
  display: flex;
  min-height: calc(100vh - 120px - 126px - 40px);
  margin-bottom: 20px;

  .reset-password-area {
    margin: 0 auto;
    padding: 3em 1em;
    width: 93%;
    border-radius: 50px;
    background-color: $primaryColorLight;
    text-align: center;
    height: 100%;

    .form-row {
      margin-bottom: 1.5rem;

      input {
        box-shadow: none !important;
      }
    }

    .reset-password-title {
      font-family: "Averia Sans Libre", sans-serif;
      color: $primaryColor;
      margin-bottom: 50px;
    }

    .mail-resent-text-area {
      font-weight: bold;
    }

    @media screen and (min-width: 993px) {
      .form {
        margin: 0 auto;
        width: 40%;
      }
    }

    @media (max-width: 993px) {
      .form {
        margin: 0 auto;
        width: 90%;
      }
    }

    .invalid-feedback {
      text-align: left;
      display: unset !important;
    }

    .validation_area {
      display: flex;
      flex-direction: column;
      align-items: center;

      .pill {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        border: 3px solid $secondaryColor;
        background-color: $secondaryColor;
        color: $whiteColor;
        height: 40px;
        border-radius: 20px;

        &:hover {
          border: 3px solid $secondaryColor;
          color: $secondaryColor;
          background-color: $backgroundColor;
        }
      }
    }
  }
}
</style>
